let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


// Free sampling page
// document.addEventListener("DOMContentLoaded", (event) => {
//   console.log("DOM fully loaded and parsed");
//   const myTimer = setInterval(() => {
//     let eleTest = document.querySelector('#sample-page-trigger');
//     if(eleTest != null){
//       console.log(eleTest, "eleTest");
//       clearInterval(myTimer)
//     }
//   }, 100);
// });


document.addEventListener("DOMContentLoaded", (event) => {
    if(enable_free_sample_page){
      let free_sample_cart_total_id_check = false;
      let cartItemsGift = CartJS.cart.items; 
      $(cartItemsGift).each(function(elem, value){
             if(value.id == free_sample_product_1 || value.id == free_sample_product_2 || value.id == free_sample_product_3 || value.id == free_sample_product_4 ){
                    free_sample_cart_total_id_check = true; 
              }
            });
            if(free_sample_cart_total_id_check){
              console.log('free sampling',  $('.inline-cart'))
              if(window.location.href  == 'https://sokoglam.com/pages/free-sampling-page'){
                 window.location.href = "https://sokoglam.com/";
              }
              const myTimer = setInterval(() => {
                let eleTest = document.querySelector('#sample-page-trigger');
                if(eleTest != null){
                  $('#sample-page-trigger').attr('href', '/checkout');
                  clearInterval(myTimer)
                }
              }, 100);
            }
            else{
              let gift_card_check = false
              $(cartItemsGift).each(function(elem, value){
                if(value.gift_card == true){
                  gift_card_check = true; 
                 }
               });
               const myTimer1 = setInterval(() => {
               if(gift_card_check){
                $('#sample-page-trigger').attr('href', '/checkout');
               }else{
                  if(document.querySelector('#sample-page-trigger') != null){
                    document.querySelector('#sample-page-trigger').setAttribute('href', '/pages/free-sampling-page');
                    clearInterval(myTimer1)
                  }
                }
              }, 100);

            }
    }
  });


  // $(document).ready(function(){
  //   if(window.location.href == 'https://sokoglam.com/pages/free-sampling-page'){
  //     $('#sample-page-trigger').attr('href', '/checkout')
  //   }else{
  //     $('#sample-page-trigger').attr('href', '/pages/free-sampling-page')
  //   }  
  // });


